import { Page } from 'common-front/src/components/page/page';
import { Button } from 'common-front/src/designSystem/components/button';
import { useHeavent } from 'common-front/src/hooks/useHeavent';
import { Box } from 'common/src/designSystem/components/box';
import { WorkflowsPaths } from 'common/src/util/paths/workflowsPaths';
import * as React from 'react';

export const WorkflowsHeader = () => {
    const {
        history,
        translate,
        params: { organizationId, eventId }
    } = useHeavent();

    return (
        <Page.Header justify="between">
            <Box font="gray900 displayXs medium">{translate('automatisations_60045')}</Box>

            <Button
                onClick={() => {
                    history.push(WorkflowsPaths.CREATE({ organizationId, eventId }));
                }}
            >
                {translate('cr_er_une_autom_91246')}
            </Button>
        </Page.Header>
    );
};
